import React from 'react';
import { useSelector } from 'react-redux';
import {
  Outlet,
  Navigate,
  useLocation,
} from 'react-router-dom';

function ArtistRoute() {
  const location = useLocation();
  const permission = useSelector(state => state.auth.user.permission);

  return permission == 3 ? <Outlet /> : <Navigate to='/home' />;
}

export default ArtistRoute;